/**
 * Frontend page-size ceiling for a single connection request. It is a
 * client-side convention (large enough for typical lists, small enough to keep
 * payloads bounded), not a verified backend cap: callers that must cover more
 * rows should chunk or paginate instead of raising `first`.
 */
export const MAX_PAGE_SIZE = 1000;
